import { eTaxCertificationRequestStatus } from './eTaxCertificationRequestStatus';

export interface ITaxCertificationRequestResponse {
  taxCertificationRequestId: string;
  orderId: string;
  vendorCompanyId: string;
  status: eTaxCertificationRequestStatus;
  createdAt: string;
  updatedAt?: string;
  eta?: string;
  orderedBy?: string;
}

export type ITaxCertificationRequestData = ITaxCertificationRequestResponse;

export const convertFromTaxCertificationRequestResponseToTaxCertificationRequestData = (
  data: ITaxCertificationRequestResponse
): ITaxCertificationRequestData => data;
